import { createFileRoute } from '@tanstack/react-router';
import { EmployeePayrollModule } from '@/modules/employee-payroll';

export const Route = createFileRoute('/(dashboard)/_dashboard/salary-slip')({
  component: EmployeePayrollModule,
});
